export const exists = (item) => {
  const result = (item.link !== '') | (item.text !== '');
  return result && item;
};
